module.exports = __webpack_public_path__ + "static/img/ws-img-newsletter.18ef489.jpg";